import React from "react";
import { Typography } from "@mui/material";
import { useSidebarAccent } from "../SidebarAccentContext";

export default function SectionLabel({ children }) {
  const { minimized } = useSidebarAccent();
  if (minimized) return null;
  return (
    <Typography
      className="drawer-section-label"
      variant="caption"
      sx={{
        display: "block",
        px: 2.5,
        pt: 2,
        pb: 0.75,
        color: "text.secondary",
        opacity: 0.7,
        fontWeight: 700,
        fontSize: "0.66rem",
        letterSpacing: "0.12em",
        textTransform: "uppercase",
      }}
    >
      {children}
    </Typography>
  );
}
